// extracted by css-extract-rspack-plugin
export default {"logo":"bestPartners-module__logo"};